import React from 'react';
import { syncBlock } from '@atlaskit/adf-schema';
import { blockTypeMessages } from '@atlaskit/editor-common/messages';
import { IconSyncBlock } from '@atlaskit/editor-common/quick-insert';
import { SyncBlockStoreManager } from '@atlaskit/editor-synced-block-provider';
import { createSyncedBlock } from './pm-plugins/actions';
import { createPlugin } from './pm-plugins/main';
import { ContentComponent } from './ui/ContentComponent';
import { getToolbarConfig } from './ui/floating-toolbar';
export var syncedBlockPlugin = function syncedBlockPlugin(_ref) {
  var config = _ref.config,
    api = _ref.api;
  var syncBlockStore = new SyncBlockStoreManager(config === null || config === void 0 ? void 0 : config.dataProvider);
  return {
    name: 'syncedBlock',
    nodes: function nodes() {
      return [{
        name: 'syncBlock',
        node: syncBlock
      }];
    },
    pmPlugins: function pmPlugins() {
      return [{
        name: 'syncedBlockPlugin',
        plugin: function plugin(params) {
          return createPlugin(config, params, syncBlockStore, api);
        }
      }];
    },
    pluginsOptions: {
      quickInsert: function quickInsert(_ref2) {
        var formatMessage = _ref2.formatMessage;
        return [{
          id: 'syncBlock',
          title: formatMessage(blockTypeMessages.syncedBlock),
          description: formatMessage(blockTypeMessages.syncedBlockDescription),
          priority: 800,
          keywords: ['synced', 'block', 'synced-block', 'sync', 'sync-block', 'auto', 'update', 'excerpt', 'connect'],
          keyshortcut: '',
          icon: function icon() {
            return /*#__PURE__*/React.createElement(IconSyncBlock, {
              label: formatMessage(blockTypeMessages.syncedBlock)
            });
          },
          action: function action(insert, state) {
            return createSyncedBlock(insert, state, syncBlockStore);
          }
        }];
      },
      floatingToolbar: function floatingToolbar(state, intl, providerFactory) {
        return getToolbarConfig(state, intl, config, providerFactory, api, syncBlockStore);
      }
    },
    contentComponent: function contentComponent() {
      return /*#__PURE__*/React.createElement(ContentComponent, {
        syncBlockStoreManager: syncBlockStore
      });
    }
  };
};